export default "__VITE_PUBLIC_ASSET__c8632b93__"